import { vdkHappinessPortalApi } from "./vdk-happiness-portal-api";
const getAllInvitationCount = () => {
    return vdkHappinessPortalApi.get("invitation/get-all-invitation-count");
};
const getPaginatedInvitationsByEventId = (query) => {
    return vdkHappinessPortalApi.post("invitation/get-paginated-invitation-by-event-id", query);
};
const ExportToExcel = (query) => {
    return vdkHappinessPortalApi.post("invitation/export-to-excel", query);
};
const deleteInvitation = (query) => {
    return vdkHappinessPortalApi.post("invitation/delete-invitation", query);
};
const ArchivingToggelingInvitation = (command) => {
    return vdkHappinessPortalApi.post("invitation/archive-toggle", command);
};
const getInvitationStats = (eventId) => {
    return vdkHappinessPortalApi.get(`invitation/get-invitation-stats/${eventId}`);
};
const getInvitationDatesByInvitationId = (id) => {
    return vdkHappinessPortalApi.get(`invitation/${id}/get-invitation-dates-by-invitation-id`);
};
const getInvitationDatesForByInvitationIdWithPreAccDate = (id) => {
    return vdkHappinessPortalApi.get(`invitation/${id}/get-invitation-dates-by-invitation-id-with-preAccDate`);
};
const getInvitationDatesByUserId = (userId) => {
    return vdkHappinessPortalApi.get(`invitation/${userId}/get-invitation-dates-by-user-id`);
};
const InvitationApi = {
    getAllInvitationCount,
    getPaginatedInvitationsByEventId,
    ExportToExcel,
    deleteInvitation,
    getInvitationStats,
    getInvitationDatesByInvitationId,
    getInvitationDatesForByInvitationIdWithPreAccDate,
    getInvitationDatesByUserId,
    ArchivingToggelingInvitation
};
export default InvitationApi;
